import React, { Component } from 'react';
import DashboardFacebookTemplate from './DashboardFacebookContainer';
import Body from '../../molecules/Body';
import { strings } from './DashboardFacebookContent';

class DashboarFacebook extends Component {
	render() {
		return (
			<Body>
				<DashboardFacebookTemplate data={strings}/>
			</Body>
		)
	}
}

export default DashboarFacebook;


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardFacebook/DashboardFacebook.jsx